export default __webpack_public_path__ + "static/media/pdffile.2ca5883a.svg";